import { AnimationPlayer } from "@/components/animation/how-ai-agents-work/AnimationPlayer"
import { animationData } from "@/components/animation/how-ai-agents-work/animationData"
import { BlueButton } from "@/components/button"
import Heading from "@/components/heading"
import useIntersectionObserver from "@react-hook/intersection-observer"
import { isNotEmpty } from "ramda-extension"
import React, { FC, useRef } from "react"
import { up } from "styled-breakpoints"
import styled from "styled-components"

interface IHowItWorks {
  anchor?: string
  link?: Queries.WpAcfLink
  title: string
  video: Queries.WpMediaItem
  videoFramePreview: Queries.WpMediaItem
}

export interface HowItWorksProps {
  className?: string
  data?: IHowItWorks
  id?: string
}

const Wrapper = styled.div<HowItWorksProps>`
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0 16px;
  margin: 0 auto;

  ${up("lg")} {
    max-width: calc(1120px + 32px);
  }
`

const AnimationWrapper = styled.div`
  display: block;
  height: 890px;
  margin: 60px auto 0;
  ${up("md")} {
    height: 720px;
  }
`

const StyledButton = styled(BlueButton)`
  display: none;

  ${up("lg")} {
    display: flex;
    margin-top: 24px;
  }
`

export const HowItWorks: FC<HowItWorksProps> = (props) => {
  const { className, data } = props

  if (!data) return null

  const { anchor, link, title } = data
  const wrapperRef = useRef<HTMLDivElement>(null)

  const { isIntersecting } = useIntersectionObserver(wrapperRef)

  return (
    <Wrapper
      className={className && className !== "" ? className : ""}
      id={anchor ?? "how_it_works"}
      ref={wrapperRef}>
      <Heading center size="h2" title={title} whiteGradient />
      <AnimationWrapper>
        {isIntersecting && <AnimationPlayer data={animationData} />}
      </AnimationWrapper>
      {isNotEmpty(link) && <StyledButton center link={link} type="url" />}
    </Wrapper>
  )
}
